import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HeroContent: React.FC = () => {
  const { t } = useTranslation();
  
  const scrollToVideo = () => {
    const videoSection = document.querySelector('.video-section');
    if (videoSection) {
      videoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToUpload = () => {
    const uploadSection = document.querySelector('#authentication-section');
    if (uploadSection) {
      uploadSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div className="text-center lg:text-left max-w-2xl animate-fade-in">
      <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-white">
        {t('landing.hero.title_part1')}{' '}
        <span className="bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent animate-pulse">
          {t('landing.hero.title_part2')}
        </span>{' '}
        {t('landing.hero.title_part3')}{' '}
        <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-indigo-400 bg-clip-text text-transparent">
          {t('landing.hero.title_part4')}
        </span>
      </h1>
      
      <p className="text-xl text-slate-300 mb-12 leading-relaxed animate-fade-in" style={{ animationDelay: '0.3s' }}>
        {t('landing.hero.subtitle_part1')}{' '}
        <span className="text-indigo-400 font-semibold">{t('landing.hero.subtitle_part2')}</span>
        {t('landing.hero.subtitle_part3')}
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-16 animate-fade-in" style={{ animationDelay: '0.6s' }}>
        <button onClick={scrollToUpload} className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-2xl hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl hover:shadow-indigo-500/25">
          {t('landing.hero.start_analysis')}
          <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform duration-300" />
        </button>
        
        <button 
          onClick={scrollToVideo}
          className="group inline-flex items-center px-8 py-4 bg-slate-800/50 text-slate-300 font-semibold rounded-2xl border border-slate-700/50 hover:bg-slate-700/50 hover:text-white hover:border-indigo-500/50 transition-all duration-300 backdrop-blur-xl"
        >
          {t('landing.hero.watch_demo')}
          <div className="w-5 h-5 ml-2 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <div className="w-0 h-0 border-l-[6px] border-l-white border-y-[4px] border-y-transparent ml-0.5"></div>
          </div>
        </button>
      </div>
      
      {/* Stats badges */}
      <div className="flex flex-wrap gap-4 justify-center lg:justify-start animate-fade-in" style={{ animationDelay: '0.9s' }}>
        <div className="flex items-center px-4 py-2 bg-slate-800/30 backdrop-blur-xl rounded-full border border-slate-700/50">
          <div className="w-2 h-2 bg-blue-400 rounded-full mr-2 animate-pulse"></div>
          <span className="text-slate-300 text-sm font-medium">{t('landing.hero.satisfaction_rate')}</span>
        </div>
      </div>
    </div>
  );
};

export default HeroContent;